import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "children", "className", "icon", "size", "withStroke"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { Icons } from '../icons/icons';
import { ButtonBase } from './button-base/button-base';
import { jsx as _jsx } from "react/jsx-runtime";
export var _Button = function _Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      children = _ref.children,
      className = _ref.className,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      _ref$withStroke = _ref.withStroke,
      withStroke = _ref$withStroke === void 0 ? true : _ref$withStroke,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _className = classNames(className, {
    'btn-icon': icon
  });

  var ButtonIcon = Icons === null || Icons === void 0 ? void 0 : Icons[icon];
  return /*#__PURE__*/_jsx(ButtonBase, _objectSpread(_objectSpread({
    withStroke: withStroke,
    className: _className,
    variant: variant,
    size: size
  }, rest), {}, {
    children: ButtonIcon ? /*#__PURE__*/_jsx(ButtonIcon, {}) : children
  }));
};
var components = {
  Primary: function Primary(props) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
      variant: "primary"
    }));
  },
  Secondary: function Secondary(props) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
      variant: "secondary"
    }));
  },
  Outline: function Outline(props) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
      variant: "outline"
    }));
  }
};
export var Button = Object.assign(_Button, components);